export default __webpack_public_path__ + "static/media/GSP5.3451b178.png";